import { useEffect, useState } from "react";

import { CONTEST_ID } from "@/components/raffle/constants";
import { request } from "@/util/request";

export const useRequest = <R extends unknown>(
  initialState: R,
  url?: string,
): R => {
  const [data, setData] = useState<R>(initialState);

  useEffect(() => {
    (async () => {
      if (url) {
        const response = await request<R>(url, {}, "prod");
        setData(response);
      }
    })();
  }, [url]);

  return url ? data : initialState;
};

export function useGetContestRaffles(contestId: number) {
  return useRequest<Raffle[]>([], `contest/${contestId}/raffles`)
    .sort(
      (raffle1, raffle2) =>
        new Date(raffle1.raffleDate).getTime() -
        new Date(raffle2.raffleDate).getTime(),
    )
    .map((raffle, index) => ({
      ...raffle,
      index,
    }));
}

export function useGetScore(contestId: number, memberAddress?: string) {
  return useRequest<Score[]>(
    [],
    memberAddress && `contest/${contestId}/member/${memberAddress}/score`,
  );
}

export function usePersonalTickets(userAddress?: string, winOnly = true) {
  return useRequest<Ticket[]>(
    [],
    userAddress &&
      `contest/${CONTEST_ID}/raffles/tickets?userAddress=${userAddress}&winTicketsOnly=${winOnly}`,
  );
}
